// extracted by mini-css-extract-plugin
export var logoWrapper = "hx_BR";